/**
 * nav-footer.js starts
 * Created by mac on 21.08.2018.
 */

$(function () {
  
  $(document).on('click', '.footer-menu__title', function(e){
    var _this = e.currentTarget;
    if ($(document).width() < 576){
      var targetMenu = document.querySelector(_this.dataset.target);
      if (targetMenu)
        $(targetMenu).toggle('fast');
    }
    
    e.preventDefault();
    
  });
  
  
});

/* nav-footer.js ends */